import {h} from "preact";
import {GlobalsContext} from "../../AppContext";
import {useContext} from "preact/hooks";
import style from './CloseTooltip.css';
import clsx from "clsx";


const CloseTooltip = () => {
    const { tooltipClose, setTooltipClose } = useContext(GlobalsContext);
    const { setWidgetHidden } = useContext(GlobalsContext);

    const handleClose = () => {
        setTooltipClose(true);
        setWidgetHidden(true);

        localStorage.setItem("tooltipClosed", "true");
    };

    return (
        <div
            className={clsx(style.root, tooltipClose ? style.close : style.open)}
            onClick={handleClose}
        />
    );
};

export default CloseTooltip;
